import React, { useContext, useEffect, useState } from "react";
// another components
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { useGestionarPostulaciones } from "../../../../hooks/useGestionarPostulaciones";
// styled components
import { Col, Row, Table, Empty, Button, Popover } from "antd";
// models
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
// icons
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import { TemplateContext } from "../../../../utils/template_context";
import { DownloadFile } from "../../../../utils/DownloadFile";

interface IProps {
  postulacion: PostulacionModel;
  descargarArchivo: any;
  lineasConvocatoria: any;
  isBeps?: boolean;
}

const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
};

export const InformacionPostulacion: React.FC<IProps> = (props: IProps) => {
  const [modalDocumento, setModalDocumento] = useState<boolean>(false);
  const [documento, setDocumento] = useState<string>("");
  const context = useContext(TemplateContext);
  // columns
  const columnasDocumentaciontecnicaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 120,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any, record: any, index: number) => (
        <div className="row">
          <div className="col-12">
            {datos.tipo_documento || datos.descripcion}
          </div>
        </div>
      ),
    },
    {
      title: "Nombre del documento",
      width: 300,
      render: (datos: any) => {
        return (
          <>
            {datos && "url_participante" in datos ? (
              datos.url_participante.length > 27 ? (
                <Popover content={datos.url_participante} title="Nombre del documento">
                  <span
                    style={{
                      fontFamily: "Montserrat-Regular",
                      cursor: "pointer",
                    }}
                  >{`${datos.url_participante.substring(0, 24)}...`}</span>
                </Popover>
              ) : (
                <span
                  style={{
                    fontFamily: "Montserrat-Regular",
                    cursor: "pointer",
                  }}
                >{`${datos.url_participante}`}</span>
              )
            ) : (
              <span
                  style={{
                    fontFamily: "Montserrat-Regular",
                    cursor: "pointer",
                  }}
                >No se cargo un documento</span>
            )}
          </>
        );
      }
    },
    {
      title: (
        <div className="row">
          <div className="col-24 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            {datos.checkaceptartecnico !== undefined ? (
              <div className="row">
                <div className="col-12 justify-content-center">
                  {datos.checkaceptartecnico === true ? (
                    <span style={{ color: coloresEstado["Aceptado"] }}>
                      Aceptado
                    </span>
                  ) : (
                    <span style={{ color: coloresEstado["Rechazado"] }}>
                      Rechazado
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <div className="justify-content-center">
                <span>Inscrito sin revisar</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: (
        <>
          <div className="row">
            <div className="col-12 justify-content-center">Acciones</div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-12 justify-content-center">Ver</div>
            <div className="col-md-6 col-sm-12 justify-content-center">Descargar</div>
          </div>
        </>
      ),
      width: 120,
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, index: number) => {
        if (datos && datos.url_participante) {
          return (
            <>
              <div className="row">
                <div className="col-6 justify-content-center">
                  <EyeOutlined
                    onClick={() => {
                      setModalDocumento(true);
                      setDocumento(datos.url_participante);
                    }}
                  />
                </div>
                <div className="col-6 justify-content-center">
                  <DownloadOutlined
                    // onClick={() => props.descargarArchivo(datos.url_participante)}
                    onClick={() => DownloadFile(datos.url_participante)}
                  />
                </div>
              </div>
            </>
          );
        }
      },
    },
  ];
  //  columns table documentación técnica
  const columnasDocumentacionadministrativaModal: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Tipo de documento",
      width: 380,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => (
        <div className="row">
          <div className="col-12">{datos.descripcion}</div>
        </div>
      ),
    },
    {
      title: (
        <div className="width-100">
          <div className="col-12 justify-content-center">Estado</div>
        </div>
      ),
      width: 100,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <div className="width-100">
              <div className="col-12 justify-content-center">
                {datos && datos.checkaceptar ? (
                  <span style={{ color: coloresEstado["Aceptado"] }}>
                    Aceptado
                  </span>
                ) : datos.checkcancelar ? (
                  <span style={{ color: coloresEstado["Rechazado"] }}>
                    Rechazado
                  </span>
                ) : datos.checksubsanable ? (
                  <span style={{ color: coloresEstado["Subsanar"] }}>
                    Subsanar
                  </span>
                ) : datos.checksubsanado ? (
                  <span style={{ color: coloresEstado["Subsanado"] }}>
                    Subsanado
                  </span>
                ) : (
                  <span style={{ color: coloresEstado["Sin Revisar"] }}>
                    Sin Revisar
                  </span>
                )}
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: (
        <>
          <div className="row">
            <div className="col-12 justify-content-center">Acciones</div>
          </div>
          <div className="row">
            <div className="col-md-6 col-sm-12 justify-content-center">Ver</div>
            <div className="col-md-6 col-sm-12 justify-content-center">Descargar</div>
          </div>
        </>
      ),
      width: 140,
      render: (datos: any, record: any, index: number) => {
        return (
          <>
            <div className="row">
              <div className="col-6 justify-content-center">
                <EyeOutlined
                  onClick={() => {
                    setModalDocumento(true);
                    setDocumento(datos.url_participante);
                  }}
                />
              </div>
              <div className="col-6 justify-content-center">
                <DownloadOutlined
                  // onClick={() => props.descargarArchivo(datos.url_participante)}
                  onClick={() => DownloadFile(datos.url_participante)}
                />
              </div>
            </div>
          </>
        );
      },
    },
  ];
  //   columns table enlaces
  const columnaslinksModal = [
    {
      title: "URL",
      width: 260,
      render: (datos: any, record: any, index: number) => {
        if (datos && datos.url) {
          return (
            <div className="row">
              <div className="col-12">
                <a target="_blank" href={datos.url}>
                  {datos.url}
                </a>
              </div>
            </div>
          );
        } else {
          return (
            <div className="row">
              <div className="col-12">
                <a target="_blank" href={"Sin Información"}>
                  Sin Información
                </a>
              </div>
            </div>
          );
        }
      },
    },
  ];

  return (
    <>
      <div
        className="row"
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "16px",
          paddingBottom: "16px",
        }}
      >
        <div
          className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
          style={{ paddingLeft: "16px" }}
        >
          Nombre representante
        </div>
        <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
          {props.postulacion.nombre_participante}
        </div>
        {props.isBeps ? null : (
          <>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Tipo de participante
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.tipo_participante === "1"
                ? "Persona Natural"
                : props.postulacion.tipo_participante === "2"
                  ? "Persona Juridica"
                  : props.postulacion.tipo_participante === "3"
                    ? "Grupo Conformado"
                    : null}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Línea
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px", background: "#F0F6FB" }}
            >
              Categorías
            </div>
            <div
              className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular"
              style={{ background: "#F0F6FB" }}
            >
              {props.postulacion.categoria_linea_convocatoria}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Estado
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.estado}
            </div>
            <div
              className="col-6 col-md-3 font-size-12px font-family-Montserrat-SemiBold"
              style={{ paddingLeft: "16px" }}
            >
              Observaciones
            </div>
            <div className="col-6 col-md-9 font-size-12px font-family-Montserrat-Regular">
              {props.postulacion.observaciones}
            </div>
          </>
        )}
        {props.postulacion.documentos_tecnicos !== null &&
          props.postulacion.documentos_tecnicos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Documentos Técnicos
            </label>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={{ hideOnSinglePage: true }}
              columns={columnasDocumentaciontecnicaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_tecnicos}
            />
          </div>
        ) : null}
        {props.postulacion.documentos_administrativos !== null &&
          props.postulacion.documentos_administrativos.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Documentos administrativos
            </label>
            <Table
              style={{ borderTop: "1px solid #C4C4C4" }}
              pagination={{ hideOnSinglePage: true }}
              columns={columnasDocumentacionadministrativaModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.documentos_administrativos}
            />
          </div>
        ) : null}
        {props.postulacion && props.postulacion.links !== null && props.postulacion.links.length > 0 ? (
          <div
            className="col-12 font-family-Montserrat-Regular font-size-13px"
            style={{ paddingTop: "16px", paddingBottom: "1%" }}
          >
            <label className="font-family-Montserrat-SemiBold">
              Enlaces del proyecto
            </label>
            <Table
              pagination={{ hideOnSinglePage: true }}
              style={{ paddingTop: "16px" }}
              columns={columnaslinksModal}
              locale={{
                emptyText: (
                  <Empty
                    description="No se han diligenciados datos para está sección"
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              dataSource={props.postulacion.links}
            />
          </div>
        ) : null}
      </div>
      {modalDocumento && (
        <ModalVisualizarDocumentos
          visualizar={modalDocumento}
          setVisualizar={setModalDocumento}
          state={{ documento: documento }}
          tipo="participante"
        />
      )}
    </>
  );
};
